import React from "react";

import { CurrencyInput } from "@components/CurrencyInput";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import styles from "../../../../styles/secrets-drawers.module.scss";
import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox";
import { Drawer } from "../../../components/Drawer";
import { Message } from "../../../components/Message";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { BaseCurrencyInput } from "../../../components";

export default class AutoCancelOpened extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      enabled: false,
      waitTime: 10,
    };
  }

  async componentDidMount() {
    const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();
    const automatic_opened_order_cancel =
      (await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "automatic_opened_order_cancel"
      )) || {};

    this.setState({
      enabled: !!automatic_opened_order_cancel.enabled,
      waitTime: automatic_opened_order_cancel.waitTime || 10,
    });
  }

  async save() {
    const { enabled, waitTime } = this.state;

    this.setState({ loading: true });
    const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();
    const automatic_opened_order_cancel =
      (await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "automatic_opened_order_cancel"
      )) || {};

    const automaticOpenedOrderCancelResponse =
      await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "automatic_opened_order_cancel",
        {
          automatic_opened_order_cancel: {
            ...automatic_opened_order_cancel,
            enabled,
            waitTime,
          },
        }
      );

    if (automaticOpenedOrderCancelResponse.getErrors([]).length > 0) {
      alert({
        text: automaticOpenedOrderCancelResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configuração alterada com sucesso",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { loading, enabled, waitTime } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Cancelar pedidos em aberto"
      >
        <div className={styles.secretDrawerContainer}>
          <Message>
            <p>
              Ao ativar essa configuração, todos os pedidos de todas as unidades
              que estiverem <b>Em Aberto </b>
              além do tempo de espera definido (em minutos), serão
              automaticamente cancelados.
            </p>
          </Message>

          <div className={styles.container}>
            <Checkbox
              name={`enabled`}
              design="two"
              checked={enabled}
              onChange={(value) => this.setState({ enabled: value })}
            >
              Cancelar pedidos em aberto
            </Checkbox>

            <BaseCurrencyInput
              label="Tempo de espera"
              design="two"
              className="w-100 mt-20"
              max={11}
              suffix={` ${waitTime == 1 ? "minuto" : "minutos"}`}
              prefix=""
              precision={0}
              value={waitTime}
              onChange={(value) => this.setState({ waitTime: value })}
            />
          </div>
          <div className={styles.footer}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.save()}
              loading={loading}
              disabled={loading || !waitTime}
            >
              Salvar
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}
